import { Box } from '@mui/material'
import { FormContainer, ImageContainer } from './AuthLayout.styled'
import WheatFieldImg from 'assets/img/WheatField.png'
import { Outlet } from 'react-router-dom'

export const AuthLayout = () => {
  return (
    <Box display="flex" width={'100%'} height={'100%'}>
      <ImageContainer>
        <img
          src={WheatFieldImg}
          srcSet={WheatFieldImg}
          alt={'WheetField'}
          loading="lazy"
        />
      </ImageContainer>
      <FormContainer>
        <Outlet />
      </FormContainer>
    </Box>
  )
}
